import { redirect } from 'react-router';
import type { LoaderFunctionArgs } from 'react-router';

const safeNext = (value: string | null): string => (value && /^\/(?!\/)[A-Za-z0-9/_?=&.-]*$/.test(value) ? value : '/');

export function authCallbackLoader({ request }: LoaderFunctionArgs): Response {
  const next = safeNext(new URL(request.url).searchParams.get('next'));
  return redirect(next === '/' ? '/signin' : `/signin?next=${encodeURIComponent(next)}`);
}

export default function AuthCallback() {
  return null;
}
